import { z } from 'zod'

import { dbEntitySchema } from './system'
import { MARKETPLACE_TYPES } from '../constants/organizationIntegration'

export const organizationMarketplaceTypeSchema = z.enum(MARKETPLACE_TYPES)

export const organizationMarketplaceAssignmentSchema = dbEntitySchema.extend({
  organization: z.string(),
  marketplaceType: organizationMarketplaceTypeSchema,
})

export const organizationMarketplaceAssignmentCreateArgsSchema = z.object({
  marketplaceType: organizationMarketplaceTypeSchema,
})

export const organizationMarketplaceAssignmentListResponseSchema = z.object({
  data: z.array(organizationMarketplaceAssignmentSchema),
})

export const organizationMarketplaceAssignmentSingleResponseSchema = z.object({
  data: organizationMarketplaceAssignmentSchema,
})
